import { useCalendarGrid, useLocale } from 'react-aria';
import { getWeeksInMonth } from '@internationalized/date';
import { CalendarCell } from './CalendarCell';
import { CalendarState, RangeCalendarState } from 'react-stately';

export function CalendarGrid({
  state,
  ...props
}: {
  state: CalendarState | RangeCalendarState;
}) {
  const { locale } = useLocale();
  const { gridProps, headerProps, weekDays } = useCalendarGrid(props, state);
  // Get the number of weeks in the month so we can render the proper number of rows.
  const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale);
  return (
    <table {...gridProps} cellPadding="0" className="flex-1">
      <thead {...headerProps} className="text-gray-600">
        <tr>
          {weekDays.map((day, index) => (
            <th className="text-center" key={index}>
              {day}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {getArray(weeksInMonth).map((weekIndex) => {
          return (
            <tr key={weekIndex}>
              {state
                .getDatesInWeek(weekIndex)
                .map((date, i) =>
                  date ? (
                    <CalendarCell key={date.day} state={state} date={date} />
                  ) : (
                    <td key={i} />
                  )
                )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

function getArray(x: number): number[] {
  const result = [];
  for (let i = 0; i < x; i++) {
    result.push(i);
  }
  return result;
}
